var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-item item--select",class:_vm.main ? 'group-start' : ''},[(_vm.main)?[_c('div',{staticClass:"item item--main"},[_c('checkbox',{attrs:{"checked":_vm.checked},on:{"change":_vm.handleSelectItem}})],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }